module.exports = __webpack_public_path__ + "img/selected0-min.03360ca2.png";